<h5>Are you sure ?</h5>
<div class="sp-between mat-form-field-flex">
  <button (click)="closeDialog(false)" class="btn">CANCEL</button>
  <button (click)="closeDialog(true)" class="btn">YES</button>
</div>
